export enum AdminNavEntryPoint {
  Merchandising = 'merchandising',
  Account = 'account',
  CatalogAdmin = 'catalog-admin',
  CampaignManagement = 'campaign-management',
  LandingPageSystem = 'landing-page-system',
}
